module.exports = __webpack_public_path__ + "static/321-1cdd072d7ecf998637add15df53bb3f6.jpeg";